import { render, staticRenderFns } from "./MetaTitle.vue?vue&type=template&id=380a0fd7"
import script from "./MetaTitle.vue?vue&type=script&lang=ts"
export * from "./MetaTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports